import posthog, { type CaptureOptions } from 'posthog-js';
import {
  FOLLOW_THROUGH_PLAN_ID,
  FOLLOW_THROUGH_PLAN_TYPES,
  type FollowThroughPlanType,
} from '@timeblock/assessment-content/assessments/follow-through-plan';

/** Router paths get basePath from Next; fetch and <img> URLs don't. */
export function withBasePath(path: string): string {
  const base = process.env.NEXT_PUBLIC_BASE_PATH;
  return base && base !== '/' ? `${base}${path}` : path;
}

export const FUNNEL_PATH = `/assessments/${FOLLOW_THROUGH_PLAN_ID}`;

type FunnelEvent =
  | 'minitools_assessment_started'
  | 'minitools_assessment_next_step'
  | 'minitools_assessment_submitted'
  | 'minitools_insight_screen_viewed'
  | 'minitools_plan_viewed'
  | 'minitools_pricing_viewed'
  | 'minitools_see_all_options_clicked'
  | 'minitools_signup_started'
  | 'minitools_signup_email_entered'
  | 'minitools_signup_completed'
  | 'minitools_signup_failed'
  | 'minitools_web_app_opened'
  | 'minitools_paywall_pricing_option_select'
  | 'minitools_paywall_checkout_initiate'
  | 'minitools_trial_started'
  | 'minitools_assessment_checkout_success';

/** Every funnel event carries the assessment type the existing minitools_* insights filter on. */
export function trackFunnel(
  event: FunnelEvent,
  properties: Record<string, unknown> = {},
  options?: CaptureOptions
) {
  posthog.capture(
    event,
    {
      assessment_type: FOLLOW_THROUGH_PLAN_ID,
      minitools_assessment_type: FOLLOW_THROUGH_PLAN_ID,
      ...properties,
    },
    options
  );
}

/** ?plan= on the sign-up and checkout pages; annual is the default, as on the pricing page. */
export function planTypeFromSearch(value: string | null): FollowThroughPlanType {
  return FOLLOW_THROUGH_PLAN_TYPES.find((type) => type === value) ?? 'annual';
}
